import { Toast } from 'vant'
import bowser from 'bowser'
import router from './../router/index'

export function makeRandom()  {
  return Math.random().toString(36).substr(2)
}

export function dateFormat(date, fmt) {
  let ret;
  const opt = {
      "Y+": date.getFullYear().toString(),        // 年
      "m+": (date.getMonth() + 1).toString(),     // 月
      "d+": date.getDate().toString(),            // 日
      "H+": date.getHours().toString(),           // 时
      "M+": date.getMinutes().toString(),         // 分
      "S+": date.getSeconds().toString()          // 秒
  };
  for (let k in opt) {
      ret = new RegExp("(" + k + ")").exec(fmt);
      if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
      };
  };
  return fmt;
}

export function splitDateToYMD(date) {
  const newDate = date.split(' ')
  return newDate[0]
}

/**
 * 小数相加 解决JS小数运算BUG
 * @param num1
 * @param num2
 * @param type 加或者减 'jia'、'jian'
 * @returns {number}
 */
export function addFloatNum(num1, num2, type) {
  num1 = parseFloat(num1);
  num2 = parseFloat(num2);
  type = type ? type : 'jia'
  var sq1, sq2, m
  try {
      sq1 = num1.toString().split(".")[1].length;
  } catch (e) {
      sq1 = 0;
  }
  try {
      sq2 = num2.toString().split(".")[1].length
  } catch (e) {
      sq2 = 0
  }
  m = Math.pow(10, Math.max(sq1, sq2))
  return type == 'jia' ? (Math.round(num1 * m) + Math.round(num2 * m)) / m : (Math.round(num1 * m) - Math.round(num2 * m)) / m
}

/**
 * 小数乘法
 * @param arg1
 * @param arg2
 * @returns {number}
 */
export function accMul(arg1,  arg2) {
  var m=0,s1=arg1.toString(),s2=arg2.toString()
  try{m+=s1.split(".")[1].length}catch(e){}
  try{m+=s2.split(".")[1].length}catch(e){}
  return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m)
}

/**
 * 保证数字有两位小数，四舍五入，不够补0
 * @param x
 * @returns {*}
 */
export function toDecimal2(x) {
  var f1 = parseFloat(x)
  if (isNaN(f1)) {
      return false
  }
  var f2 = Math.round(x*100)/100
  var s = f2.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
      rs = s.length;
      s += '.'
  }
  while (s.length <= rs + 2) {
      s += '0'
  }
  return s;
}

export function ToastLoading (message = '加载中', loadingType  = 'spinner'){
  Toast.loading({
    duration: 0,
    message,
    forbidClick: true,
    loadingType
  })
}

export function isArray(val) {
  return Object.prototype.toString.call(val) === '[object Array]';
}

/**
 * 获取query值
 * @param {*} key
 */
export function getQueryString(key) {
  let reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i') 
  let result = window.location.search.substr(1).match(reg)
  return result ? decodeURIComponent(result[2]) : null
}

/**
 * 格式化富文本图片
 * 
*/
export function formatRichTextImg(html) {
  let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
    match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
    match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
    match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
    return match;
  });
  newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
    match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
    return match;
  });
  newContent = newContent.replace(/<br[^>]*\/>/gi, '');
  newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%; height: auto;"');  
  return newContent;
}

export function isMobile(phone) {
  let val = phone.replace(/\s/g, '')
  if (!val) {
    return false
  } else {
    if (val.toString().length === 11 && val.toString()[0] == 1) {
      return true
    } else {
      return false
    }
  }
}

export function shareDownUrl() {
  const androidUrl = 'http://daoxuebang.360sheji.cn/android/app-debug.apk'
  const iosUrl = 'https://itunes.apple.com/cn/app/id1474201365?mt=8'
  const jumpUrl = bowser.ios ? iosUrl : androidUrl
  
  if(bowser.ios) {
    window.location.href = iosUrl
  } else {
    window.location.href = 'xuzunsoft://pupil:1024/Start2Activity'

    setTimeout(() => {
      router.push('/awaken')
    }, 10000)
    
  }
} 



// WEBPACK FOOTER //
// ./src/utils/helper.js